export default "/images/d8dedd582427f0fe49cf8befd6a71f66.png";